__turbopack_context__.v({
  "icon": "iIiBUG_icon",
  "root": "iIiBUG_root",
});
